import baseAPI from "@/api/base";
import { GetContactTag, RegisterContactTag } from "@/dtos/ContactTag.dto";
import {
  DELETE_CONTACT_TAG_URL,
  EDIT_CONTACT_TAG_URL,
  GET_CONTACT_TAG_URL,
  REGISTER_CONTACT_TAG_URL,
} from "@/utils/urls";
import { AxiosResponse } from "axios";

class ContactTag {
  static getContactTags = async (getContactTag: GetContactTag): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_CONTACT_TAG_URL, {
      params: getContactTag,
    });
    return response;
  };

  static registerContactTag = async (
    registerContactTag: RegisterContactTag
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(REGISTER_CONTACT_TAG_URL, {
      ...registerContactTag,
    });
    return response;
  };

  static deleteContactTag = async (id: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(`${DELETE_CONTACT_TAG_URL}/${id}`);
    return response;
  };
}

export default ContactTag;
